__turbopack_context__.v({
  "blocksBackgroundColor": "ContentItemSelect-module-scss-module__XyUuzq__blocksBackgroundColor",
  "blocksFontColor": "ContentItemSelect-module-scss-module__XyUuzq__blocksFontColor",
  "container": "ContentItemSelect-module-scss-module__XyUuzq__container",
  "headerText": "ContentItemSelect-module-scss-module__XyUuzq__headerText",
  "secondaryNavBackgroundColor": "ContentItemSelect-module-scss-module__XyUuzq__secondaryNavBackgroundColor",
  "themeBackgroundColor": "ContentItemSelect-module-scss-module__XyUuzq__themeBackgroundColor",
  "themeFontColor": "ContentItemSelect-module-scss-module__XyUuzq__themeFontColor",
  "themeFontFamily": "ContentItemSelect-module-scss-module__XyUuzq__themeFontFamily",
  "urlEditor": "ContentItemSelect-module-scss-module__XyUuzq__urlEditor",
});
